import React, { Component } from 'react';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { redirectToStore } from '../../utils/stores';

import { getPlanList } from '../../_redux/actions/plan';
import {
	setPlanOrder,
	getOrderValue,
	updateAddressOrder
} from '../../_redux/actions/order';
import Header from '../../Components/Header';
import { FaThumbsUp } from 'react-icons/fa';
import './index.scss';

import NavBtn from '../../Components/NavBtn';
import StepCounter from '../../Components/StepCounter';
import numeral from 'numeral';

import { hotjar } from 'react-hotjar';
import { PageView, initGA } from '../../Components/Tracking';

import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import FormCarrinho from '../../style/styledComponents/FormCarrinho';
import BoxSize from '../../style/styledComponents/BoxSize';
import Container from '../../style/styledComponents/Container';

class Carrinho extends Component {
	constructor() {
		super();

		this.state = {
			planError: false,
			subscriptionOption: null,
			setCupom: false,
			gracePeriod: false,
			showBox: false,
			showGraceMsg: false,
			planIdSelected: null,
			signaturePlans: [],
			planData: {},
			hasUsedCard: null,
			showAddress: null,
			hasMultiplesPlan: true,
			isDisabled: true,
			errorOnField: [],
			valueAddressId: '',
			valueId: '',
			valueName: ''
		};

		this.setOrderPlan = this.setOrderPlan.bind(this);
		this.setGracePeriod = this.setGracePeriod.bind(this);
		this.goPayment = this.goPayment.bind(this);
		this.planErrorAccept = this.planErrorAccept.bind(this);
		this.goBack = this.goBack.bind(this);
		this.setVisiblePlanData = this.setVisiblePlanData.bind(this);
	}
	componentDidMount() {
		let { Order, Plan } = this.props;
		const planType = sessionStorage.getItem('planType');
		let showBox = Plan.list.some(plan => plan.gracePeriodTax);
		let showGraceMsg = Plan.list.some(plan => plan.hasGracePeriod === '1');
		let planIdSelected = Plan.list.find(plan => plan.gracePeriodTax === null);
		let hasUsedCard = Plan.list.some(plan => plan.used_card === '1');
		let showAddressBox = Plan.list.some(
			plan => plan.used_card === '1' && plan.signature_type == planType
		);

		let hasMultiplesPlan = Plan.list.length > 2 ? true : false;

		const { loja } = this.props.match.params;
		initGA();
		PageView(`/loja/${loja}/carrinho`);
		hotjar.initialize(937897, 6);
		if (Order.data.planId) {
			this.setState({ isDisabled: false });
		}

		if (Order.data.orderId) {
			this.props.getOrderValue(Order.data.orderId);
		} else {
			redirectToStore();
		}

		this.setState({
			showBox,
			showGraceMsg,
			hasUsedCard,
			hasMultiplesPlan,
			showAddress: showAddressBox,
			planIdSelected: planIdSelected.planId
		});
	}

	setGracePeriod(e) {
		let { Plan, Order } = this.props;
		let plans = Plan.list;
		let planId = this.state.planIdSelected;
		let orderId = Order.data.orderId;
		if (orderId && this.state.gracePeriod === false) {
			const plan = plans.find(p => p.planId === planId);
			planId = plan.grace_plan_id;
			this.setState({
				planIdSelected: planId,
				gracePeriod: true
			});
		}
		if (orderId && this.state.gracePeriod === true) {
			const plan = plans.find(p => p.grace_plan_id === planId);
			planId = plan.planId;
			this.setState({
				planIdSelected: planId,
				gracePeriod: false
			});
		}
		this.props.setPlanOrder(planId, orderId);
	}
	setOrderPlan(e) {
		let { Order } = this.props;
		let planId = e.target.value;
		let orderId = Order.data.orderId;
		if (planId && orderId) {
			this.props.setPlanOrder(planId, orderId);
			this.setState({ planIdSelected: planId, isDisabled: false });
		}
	}

	goBack() {
		this.props.history.goBack();
	}

	goPayment() {
		let { Order } = this.props;
		let { loja } = this.props.match.params;
		if (Order.data.planId) {
			this.props.history.push(process.env.PUBLIC_URL + `/${loja}/pagamento`);
		} else {
			this.setState({
				planError: true
			});
		}
	}
	findPlanById(planId) {
		let dataReturn = null;
		let { Plan } = this.props;
		if (!Plan.list.error) {
			Plan.list.forEach(planItem => {
				if (planItem.planId === planId) {
					dataReturn = planItem;
				}
			});
		}

		return dataReturn;
	}
	planErrorAccept() {
		this.setState({
			planError: false
		});
	}

	// callback function that changes the state of the component to store the data of the active slide and
	// display detailed information whenever the slider moves
	setVisiblePlanData(slide) {
		const slideIndex = slide._i;
		const planData = this.state.filteredPlans[slideIndex];

		if (planData?.planId !== this.state.planData?.planId) {
			this.setState(state => ({ planData }));
		}
	}

	render() {
		let { Subscription, Plan, Order, Auth, Cupom, Address } = this.props;
		let orderValue = Order.value;

		const planType = sessionStorage.getItem('planType');

		const title =
			planType === 'saude'
				? planType.replace('u', 'ú')
				: planType === 'familia'
				? planType.replace('i', 'í')
				: planType;

		const locale = 'pt-BR';
		const currency = 'BRL';
		const currencySymbol = 'R$ ';
		const numberFormat = '0,0.00';
		const fullCurrencyFormat = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currency
		});
		const currencyFormat = new Intl.NumberFormat(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});

		let subscriptionCount = Subscription.data.itens.length;
		let orderTotalPlanValue = '';
		let orderFinalPlanValue = '';
		if (orderValue.total) {
			orderTotalPlanValue = fullCurrencyFormat.format(orderValue.planRealValue);
			orderFinalPlanValue = fullCurrencyFormat.format(
				orderValue.total +
					Number(orderValue.delivery) +
					Number(orderValue.gracePeriodValue)
			);
		}

		let orderGracePeriodValue = '';
		if (orderValue.total) {
			if (
				numeral(orderValue.gracePeriodValue).format(numberFormat) === '0.00'
			) {
				orderGracePeriodValue = '';
			} else {
				let planSelected = Order.data.planId;
				var planData = this.findPlanById(planSelected);
				orderGracePeriodValue = fullCurrencyFormat.format(
					orderValue.gracePeriodValue
				);
			}
		}

		let planSelected = '';
		if (!Plan.list.length && Auth.login.logged) {
		} else if (Order.data.planId) {
			planSelected = Order.data.planId;
			if (!orderValue.total) {
				this.props.getOrderValue(Order.data.orderId);
			}
		}

		let planBoxes = [];
		let textInstallment = null;
		let itemToShow = this.state.gracePeriod === false ? '1' : '0';
		let installmentValue = null;
		let textTotal = null;

		if (!Plan.list.error) {
			let signaturePlans = Plan.list.filter(
				plan => plan.signature_type === planType
			);
			if (signaturePlans.length === 0) {
				signaturePlans = Plan.list.filter(
					plan => plan.signature_type === 'padrao'
				);
			}

			if (!this.state.signaturePlans.length) {
				this.setState({ signaturePlans });
			}

			// 1. We get the most expensive plan...
			const highestPrice = signaturePlans.reduce((maxPrice, plan) => {
				const pricePerInstallment = plan.price / plan.numberOfInstallment;
				const yearlyPrice = pricePerInstallment * 12;
				return yearlyPrice > maxPrice ? yearlyPrice : maxPrice;
			}, 0);

			// filtering the list of plans to be displayed on cards/carousel
			const filteredPlans = signaturePlans.filter(
				item => item.visible === itemToShow
			);
			if (!this.state.filteredPlans?.length) {
				this.setState({ filteredPlans });
			}

			// 2. For each plan...
			planBoxes = filteredPlans.map(item => {
				// 3. ...we get the ratio between current anual
				const anualPriceInPlan = (item.price / item.numberOfInstallment) * 12;

				// Here, i divide this total amount by the total amount of the quarterly plan
				const ratio = Number(anualPriceInPlan) / Number(highestPrice);

				// returns the value of a number rounded to the nearest integer.
				const percentDiscount = Math.round((1 - ratio) * 100);

				installmentValue = item.price / item.numberOfInstallment;

				textTotal =
					item.numberOfInstallment == 1 ? (
						<span className='text-total'> Cobrança recorrente mensal </span>
					) : (
						<span className='text-total'>
							Total{' '}
							{item.numberOfInstallment == 6
								? 'Semestral'
								: item.numberOfInstallment == 12
								? 'Anual'
								: 'Trimestral'}
							:{' '}
							{fullCurrencyFormat.format(
								// adds the amount of the installment if the grace period is checked
								// this implementation has yet to be verified
								installmentValue * item.numberOfInstallment +
									(this.state.gracePeriod ? installmentValue : 0)
							)}
						</span>
					);
				textInstallment =
					item.numberOfInstallment == 1 ? (
						<div>
							<h2>
								<article></article>
								{currencySymbol}
								<strong>{currencyFormat.format(installmentValue)}</strong>
								<sub></sub>
							</h2>{' '}
						</div>
					) : (
						<h2 className='text-installment'>
							<span>Em até {item.numberOfInstallment}x</span>
							<div className='installment-price'>
								{currencySymbol}
								<strong>{currencyFormat.format(installmentValue)}</strong>
							</div>
						</h2>
					);

				return (
					// Cards carousel
					<SplideSlide key={item.planId} className='installments'>
						<div
							className={`installment ${
								planSelected === item.planId ? 'active' : ''
							}`}>
							<label htmlFor={item.planId}>
								<h2 className={percentDiscount ? 'title avoid-tag' : 'title'}>
									{item.name}
								</h2>
								{textInstallment}
								<p className='total'>{textTotal}</p>
								{percentDiscount ? (
									<div className='tag'>{percentDiscount}%</div>
								) : (
									''
								)}
							</label>
							<div className='box'></div>
							<input
								key={item.planId}
								id={item.planId}
								value={item.planId}
								type='radio'
								name='planos'
							/>
						</div>
					</SplideSlide>
				);
			});
		}

		let errorElm = null;

		if (this.state.planError) {
			errorElm = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<p> Selecione o período da sua assinatura!</p>
						</div>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-ok'
								onClick={this.planErrorAccept}>
								<FaThumbsUp size={18} color={'#0a53a6'} /> Ok
							</button>
						</div>
					</div>
				</div>
			);
		}

		let graceBox = null;
		let gracePeriodChecked = this.state.gracePeriod === true ? '"checked"' : '';
		const plans = Plan.list;

		if (this.state.showBox) {
			graceBox = (
				<div className='container-checkbox'>
					<input
						type='checkbox'
						id='grace'
						className='grace'
						name='grace'
						onChange={this.setGracePeriod}
						value={planSelected}
						checked={gracePeriodChecked}
					/>
					<span className='checkmark'></span>
					<label htmlFor='grace' className='benefits-add2'>
						<strong>
							Desejo comprar a carência pelo valor de uma mensalidade, para
							utilizar meus benefícios imediatamente após o pagamento da adesão.
						</strong>
					</label>
				</div>
			);
		}
		const pathArray = window.location.pathname.split('/');
		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<Container>
					<Header {...this.props} />

					<div className='col-xs-12 col-md-offset-1 col-md-10'>
						<div className='form-step'>
							{errorElm}
							<div className='checkout checkout-1'>
								<BoxSize>
									<div className='row '>
										<NavBtn
											goBack={this.goBack}
											goBackText={'VOLTAR'}
											goForward={false}></NavBtn>{' '}
										<StepCounter
											assinatura={true}
											assinante={false}
											pagamento={false}
											endereco={false}
										/>
									</div>
								</BoxSize>

								<div className='checkout-items'>
									<div className='row'>
										<div className='gray'>
											<div className='row'>
												<FormCarrinho className='col-xs-12 col-md-12'>
													<div
														className='plans'
														onChange={this.setOrderPlan}
														value={planSelected}>
														<h3>
															Como você deseja pagar a sua assinatura{' '}
															<strong>yalo {title}</strong>?
														</h3>
														<div className='row'>
															{/* Carousel = inactive carousel in web but active mode in mobile */}
															<Splide
																onActive={this.setVisiblePlanData}
																className='installments'
																options={{
																	flickPower: 300,
																	autoWidth: true,
																	arrows: false,
																	gap: '2rem',
																	pagination: false,
																	trimSpace: true,
																	focus: 'center',
																	breakpoints: {
																		767: {
																			trimSpace: false,
																			destroy: false
																		}
																	},
																	destroy: true
																}}>
																{planBoxes}
															</Splide>
														</div>
													</div>
													<div className='graceText'>
														{this.state.showGraceMsg
															? this.state.hasMultiplesPlan
																? 'Todas as assinaturas tem carência de 30 dias.'
																: 'A assinatura possui uma carência de 30 dias.'
															: ''}
													</div>
													{graceBox}

													<div className='text-information-plan visible-xs'>
														<div className='title'>Preços individuais</div>
														<div className='info-block'>
															<h3>Renovação automática</h3>
															<div>
																<p>
																	A cada{' '}
																	{this.state.planData.numberOfInstallment}{' '}
																	meses
																</p>
																<p className='details'>
																	Desligamento da renovação sem custo
																</p>
																<p></p>
															</div>
														</div>
														<hr />
													</div>
													<div className='graceText visible-sm visible-lg'>
														A sua assinatura será renovada automaticamente ao
														término da vigência.
														<br /> O cancelamento desta renovação pode ser feito
														a qualquer momento através da nossa central de
														atendimento.
													</div>
												</FormCarrinho>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<NavBtn
							goForward={this.goPayment}
							disabled={this.state.isDisabled}
							goForwardText={'PRÓXIMO PASSO'}
							step={'cart'}></NavBtn>
					</div>
				</Container>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			getPlanList,
			setPlanOrder,
			getOrderValue,
			updateAddressOrder
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Carrinho);
